import { Github, Twitter } from "lucide-react";

const Footer = () => (
  <footer className="w-full border-t bg-card/90 py-6 mt-24">
    <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
      <div className="text-sm text-muted-foreground">© {new Date().getFullYear()} VideoEditor. All rights reserved.</div>
      <div className="flex gap-4 text-muted-foreground">
        <a href="#" className="hover:text-blue-500 transition" aria-label="Twitter"><Twitter className="w-5 h-5" /></a>
        <a href="#" className="hover:text-blue-500 transition" aria-label="GitHub"><Github className="w-5 h-5" /></a>
      </div>
    </div>
  </footer>
);

export default Footer;
